import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBonsaiModule } from '@mhe/ngx-bonsai-reader';
import { AlertModule, ButtonModule, CheckboxModule } from '@mhe/ngx-shared';
import { TooltipModule } from '@mhe/ngx-shared/tooltip';
import { CommonDirectivesModule } from '@mhe/reader/common';
import { TranslateModule } from '@ngx-translate/core';

import { PlacemarkListComponent } from './placemark-list.component';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnnotationListModule } from '../annotation-list.module';
import {
  AnnotationListFooterComponent,
} from '../annotation-list-footer/annotation-list-footer.component';
import {
  AnnotationListHeaderComponent,
} from '../annotation-list-header/annotation-list-header.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgxBonsaiModule,
    CommonDirectivesModule,
    AlertModule,
    ButtonModule,
    TooltipModule,
    CheckboxModule,
    MatProgressSpinnerModule,
    AnnotationListModule,
    AnnotationListHeaderComponent,
    AnnotationListFooterComponent,
  ],
  declarations: [PlacemarkListComponent],
  exports: [PlacemarkListComponent],
})
export class PlacemarkListModule {}
